import React from 'react'
import { useGetVisitFrequenciesQuery } from '../../../../redux/service/careplan_service';

function CareplanRecommendVisitFrequencies({ listData = [], loading = false, legacyMode = false }) {
  const { data, isLoading, isFetching } = useGetVisitFrequenciesQuery(
    { skip_encounter: true },
    { skip: !legacyMode }
  );
  const rows = legacyMode ? data?.data || [] : listData;
  const isLoadingState = legacyMode ? isLoading || isFetching : loading;

  if (isLoadingState) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white px-4 py-8 text-center text-sm text-gray-500 shadow-sm mt-3">
        Loading...
      </div>
    );
  }

  return (
    <div>
      {rows.length > 0 ? (
        <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm mt-3">
          <table className="min-w-[1100px] w-full text-sm text-left">
            <thead className="bg-gray-50 text-gray-700">
              <tr>
                <th className="px-4 py-3 font-semibold">Condition</th>
                <th className="px-4 py-3 font-semibold">Visit Frequency</th>
                <th className="px-4 py-3 font-semibold">Why This Timing?</th>
                <th className="px-4 py-3 font-semibold">What Gets Better? (Expected Outcomes)</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {rows.map((row, index) => (
                <tr key={row.slug || row.condition} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'}>
                  <td className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap">{row.condition}</td>
                  <td className="px-4 py-3 text-gray-700">{row.visit_frequency}</td>
                  <td className="px-4 py-3 text-gray-700">{row.why}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-2">
                      {row.expected_outcomes?.map((outcome) => (
                        <span
                          key={outcome}
                          className="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700"
                        >
                          {outcome}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="rounded-lg border border-gray-200 bg-white px-4 py-8 text-center text-sm text-gray-500 shadow-sm mt-3">
          No matching conditions found for the patient.
        </div>
      )}
    </div>
  )
}

export default CareplanRecommendVisitFrequencies
